"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPopper = require("react-popper");
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/Tooltip.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Tooltip = function Tooltip(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 1 : _ref$size,
    text = _ref.text,
    children = _ref.children,
    id = _ref.id,
    srText = _ref.srText,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 10 : _ref$zIndex,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes;
  var componentName = 'Tooltip';
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    referenceElement = _useState4[0],
    setReferenceElement = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    popperElement = _useState6[0],
    setPopperElement = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    arrowElement = _useState8[0],
    setArrowElement = _useState8[1];
  var customOffsetModifier = (0, _react.useMemo)(function () {
    return {
      name: 'offset',
      options: {
        offset: function offset(_ref2) {
          var placement = _ref2.placement;
          if (placement === 'top') return [0, 8];
          return [0, 12];
        }
      }
    };
  }, []);
  var _usePopper = (0, _reactPopper.usePopper)(referenceElement, popperElement, {
      modifiers: [{
        name: 'arrow',
        options: {
          element: arrowElement
        }
      }, customOffsetModifier, {
        name: 'preventOverflow',
        options: {
          padding: {
            left: 16,
            right: 16,
            bottom: 8
          }
        }
      }],
      placement: 'top'
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var openTooltip = function openTooltip() {
    setIsOpen(true);
  };
  var closeTooltip = function closeTooltip() {
    setIsOpen(false);
  };

  /** Option to close Tooltip with Escape key to improve accessibility */
  var closeOnEscapeKey = function closeOnEscapeKey(event) {
    if (event.key === 'Escape') {
      closeTooltip();
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', closeOnEscapeKey);
    return function () {
      window.removeEventListener('keydown', closeOnEscapeKey);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.TooltipTrigger, {
    ref: setReferenceElement,
    role: "button",
    onMouseOver: openTooltip,
    onFocus: openTooltip,
    onMouseLeave: closeTooltip,
    onBlur: closeTooltip,
    tabIndex: 0,
    "aria-describedby": id,
    "aria-label": srText,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'trigger')
  }, children), /*#__PURE__*/_react["default"].createElement(Styled.TooltipWrapper, null, isOpen && /*#__PURE__*/_react["default"].createElement(Styled.TooltipBody, _extends({
    role: "tooltip",
    appearance: appearance,
    size: size,
    zIndex: zIndex,
    id: id,
    ref: setPopperElement,
    style: styles.popper,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes, attributes.popper), text, /*#__PURE__*/_react["default"].createElement(Styled.TooltipArrow, {
    appearance: appearance,
    ref: setArrowElement,
    style: styles.arrow,
    zIndex: zIndex,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'arrow')
  }))));
};
Tooltip.displayName = "Tooltip";
var _default = /*#__PURE__*/(0, _react.memo)(Tooltip);
exports["default"] = _default;
//# sourceMappingURL=Tooltip.js.map